import { render } from "./Dropdown.vue?vue&type=template&id=65bcc1e2&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=65bcc1e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65bcc1e2"

export default script